var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66406 6.87467V2.74967C3.66406 2.50656 3.76064 2.2734 3.93255 2.10149C4.10446 1.92958 4.33761 1.83301 4.58073 1.83301H17.4141C17.6572 1.83301 17.8903 1.92958 18.0622 2.10149C18.2342 2.2734 18.3307 2.50656 18.3307 2.74967V19.2497C18.3307 19.4928 18.2342 19.7259 18.0622 19.8979C17.8903 20.0698 17.6572 20.1663 17.4141 20.1663H4.58073C4.33761 20.1663 4.10446 20.0698 3.93255 19.8979C3.76064 19.7259 3.66406 19.4928 3.66406 19.2497V15.1247",
    stroke: "#F9FCFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.207 6.875H15.582M12.832 10.5417H15.582M12.832 14.2083H15.582",
    stroke: "#F9FCFF",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58203 9.625L7.33203 12.375M7.33203 9.625L4.58203 12.375M1.83203 6.875H10.082V15.125H1.83203V6.875Z",
    stroke: "#F9FCFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetExcel);
export default __webpack_public_path__ + "static/media/getExcel.84f7b8ee340d986875408fbc17ac689d.svg";
export { ForwardRef as ReactComponent };